module.exports = __webpack_public_path__ + "img/status_5.c0c1d590.svg";